import * as yup from 'yup';
import {
 
  validEmailRegex,
 
  validNameRegex,
 
  validUsernameRegex,

} from '../../../utils/const';
import { t } from 'react-switch-lang';
export const UsersSchema = yup.object().shape({
    login: yup
      .string()
      .trim()
      .required(t('message.fieldRequired'))
      .matches(validUsernameRegex, t('message.fieldNotValid'))
      .max(50, `${t('message.max50')}`)
      .min(3, `${t('message.min3')}`),
    firstName: yup
      .string()
      .trim()
      .required(t('message.fieldRequired'))
      .matches(validNameRegex, t('message.fieldNotValid'))
      .max(50, `${t('message.max50')}`)
      .min(3, `${t('message.min3')}`),
    lastName: yup
      .string()
      .trim()
      .required(t('message.fieldRequired'))
      .matches(validNameRegex, t('message.fieldNotValid'))
      .max(50, `${t('message.max50')}`)
      .min(3, `${t('message.min3')}`),
    email: yup
      .string()
      .trim()
      .required(t('message.fieldRequired'))
      .matches(validEmailRegex, t('message.fieldNotValid')),
      authorities: yup.array().required(t('message.fieldRequired')),
    
  });